<!--
  SupportFileThumbnail.svelte — a small local preview of an image picked for
  upload, before it is sent.

  The object URL lives exactly as long as the file is shown: created when it
  arrives, revoked when it changes or the chip goes away, so removing a file
  from the list frees its bytes. A file the browser cannot draw (a TIFF, say)
  hides its broken image and shows an image glyph instead.
-->
<script lang="ts">
	interface Props {
		/** The picked image. */
		file: File;
	}

	let { file }: Props = $props();

	/** The preview URL of the current file. */
	let url = $state<string | null>(null);
	/** Whether the browser could not draw the image. */
	let failed = $state(false);

	/* One URL per file: made when the file arrives, revoked when it changes or the
	   chip goes away. The effect writes `url` but never reads it, so it cannot loop. */
	$effect(() => {
		const next = URL.createObjectURL(file);
		url = next;
		return () => URL.revokeObjectURL(next);
	});
</script>

{#if failed || !url}
	<i class="fa-solid fa-image"></i>
{:else}
	<img src={url} alt="" class="h-8 w-8 rounded object-cover" onerror={() => (failed = true)} />
{/if}
